module.exports = __webpack_public_path__ + "img/c10bec8ecf730f0d58c7fc4a94dd2116.d7e33c39.png";